// extracted by mini-css-extract-plugin
export var centerText = "_c6-8";
export var container = "_c6-0";
export var doughnutContainer = "_c6-7";
export var legend = "_c6-a";
export var legendItemColorDisplay = "_c6-b";
export var legendItemLabel = "_c6-d";
export var legendItemValue = "_c6-c";
export var lg = "_c6-5";
export var maxWidth = "_c6-9";
export var md = "_c6-4";
export var responsive = "_c6-6";
export var sm = "_c6-3";
export var xs = "_c6-2";
export var xxs = "_c6-1";